import { DcRuntimeApi } from '@api/bff/openapi/endpoints/dc-runtime-api';
import { EquipmentApi } from '@api/enterprise/openapi';
import { bffApiClient } from '@api/bff/client';
import { enterpriseApiClient } from '@api/enterprise/client';
import type { DcRuntimeViewModel } from '@api/bff/openapi/models';
import type { EquipmentViewModel } from '@api/enterprise/openapi/models';

const dcRuntimeApi = new DcRuntimeApi(undefined, undefined, bffApiClient);

const equipmentApi = new EquipmentApi(
  undefined,
  undefined,
  enterpriseApiClient
);

export const fetchEquipment = async (
  companyName: string,
  id: string
): Promise<EquipmentViewModel | null> => {
  try {
    const response = await equipmentApi.apiEquipmentCompanyNameIdGet({
      companyName,
      id
    });
    return response.data;
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as { response?: { status?: number } };
      if (axiosError.response?.status === 404) {
        return null;
      }
    }
    return null;
  }
};

export const fetchCalibrationRuntimeByWoDetail = async (
  woDetailGlobalId: string
): Promise<DcRuntimeViewModel | null> => {
  try {
    const response =
      await dcRuntimeApi.apiDcRuntimeByWoDetailWoDetailGlobalIdGet({
        woDetailGlobalId
      });
    return response.data;
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as { response?: { status?: number } };
      if (axiosError.response?.status === 204) {
        return null;
      }
    }
    throw error;
  }
};
